import { getConfigApi } from 'Api/ConfigApi';
import { updatePrimaryFooter } from 'State/Layouts/LayoutActions';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PrimaryFooter from './PrimaryFooter';

export function PrimaryFooterContainer() {
  const dispatch = useDispatch();
  const { footerContent } = useSelector((s) => s.pageLayout);

  useEffect(() => {
    const fetchAndUpdateFooterWithContent = async () => {
      try {
        const footerResponse = await getConfigApi('/footer');
        if (footerResponse.data) dispatch(updatePrimaryFooter(footerResponse.data));
      } catch (err) {
        console.error(err.message);
      }
    };
    if (!footerContent.isLoaded) {
      fetchAndUpdateFooterWithContent();
    }
  }, [footerContent.isLoaded, dispatch]);

  if (!footerContent.isLoaded) {
    return null;
  }

  return <PrimaryFooter {...footerContent.content} />;
}
